import auth from './authentication'
import token from "./token"
import message from "./message"
import app from "./app"
import systemInfo from "./systemInfo"

const rootReducer = {
    auth, token, message, app, systemInfo
}

export default rootReducer
